module.exports = __webpack_public_path__ + "img/texiao-_0000s_0006_7.cc7ba206.png";